import React from "react";
import LineChart from "./components/LineChart";
import CustomCard from "../Card";

const TimePeriod: React.FC = React.memo(() => {
  return (
    <CustomCard heading="CASE /" subHeading="TIME PERIOD">
      <LineChart />
    </CustomCard>
  );
});

export default TimePeriod;
